export enum ListingEnquiryTitleMode {
  User = 'user',
  Listing = 'listing',
}
